const DRAFT_PREFIX = "zrs_vip_sim_draft";

function draftKey(userId) {
    return userId ? `${DRAFT_PREFIX}:${userId}` : DRAFT_PREFIX;
}

/**
 * @param {string | null | undefined} userId
 * @returns {{ sim?: object; name?: string; budget?: number; benefitState?: object; tab?: string } | null}
 */
export function loadVipSimulatorDraft(userId) {
    if (typeof sessionStorage === "undefined") return null;
    try {
        const raw = sessionStorage.getItem(draftKey(userId));
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== "object") return null;
        return parsed;
    } catch {
        return null;
    }
}

/**
 * @param {string | null | undefined} userId
 * @param {{ sim: object; name: string; budget: number; benefitState: object; tab: string }} draft
 */
export function saveVipSimulatorDraft(userId, draft) {
    if (typeof sessionStorage === "undefined") return;
    try {
        sessionStorage.setItem(
            draftKey(userId),
            JSON.stringify({
                sim: draft.sim,
                name: draft.name,
                budget: draft.budget,
                benefitState: draft.benefitState,
                tab: draft.tab,
                savedAt: Date.now(),
            }),
        );
    } catch (e) {
        console.warn("[vipSimulatorDraftStorage]", e);
    }
}

export function clearVipSimulatorDraft(userId) {
    if (typeof sessionStorage === "undefined") return;
    try {
        sessionStorage.removeItem(draftKey(userId));
    } catch {
        /* ignore */
    }
}
